module.exports = __webpack_public_path__ + "static/img/10007 (4).6411b22.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10007 (4).webp
// module id = KKO+
// module chunks = 14